import { createSlice } from "@reduxjs/toolkit";

const emptyAsync = { data: [], isLoading: false, error: null };

const initialState = {
  mapScans: { ...emptyAsync },
  lineChart: { data: [], isLoading: false, error: null },
  pieChart: { totalCount: 0, totalSuspended: 0, isLoading: false, error: null },
  countryTable: { ...emptyAsync },
  companyScansTable: { ...emptyAsync },
  companyGenerateTable: { ...emptyAsync },
  companyAssignedTable: { ...emptyAsync },
  generatedAssignedGraph: { data: {}, isLoading: false, error: null },
  allCompanies: [],
  top20Companies: [],
  filter: {
    companyIds: [],
    startDate: null,
    endDate: null,
    isTop20Companies: true,
  },
};

const slice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setMapScans(state, action) { state.mapScans = { ...state.mapScans, ...action.payload }; },
    setLineChart(state, action) { state.lineChart = { ...state.lineChart, ...action.payload }; },
    setPieChart(state, action) { state.pieChart = { ...state.pieChart, ...action.payload }; },
    setCountryTable(state, action) { state.countryTable = { ...state.countryTable, ...action.payload }; },
    setCompanyScansTable(state, action) { state.companyScansTable = { ...state.companyScansTable, ...action.payload }; },
    setCompanyGenerateTable(state, action) { state.companyGenerateTable = { ...state.companyGenerateTable, ...action.payload }; },
    setCompanyAssignedTable(state, action) { state.companyAssignedTable = { ...state.companyAssignedTable, ...action.payload }; },
    setGeneratedAssignedGraph(state, action) { state.generatedAssignedGraph = { ...state.generatedAssignedGraph, ...action.payload }; },
    setAllCompanies(state, action) { state.allCompanies = action.payload || []; },
    setTop20Companies(state, action) { state.top20Companies = action.payload || []; },
    setFilter(state, action) { state.filter = { ...state.filter, ...action.payload }; },
  },
});

export const {
  setMapScans, setLineChart, setPieChart, setCountryTable,
  setCompanyScansTable, setCompanyGenerateTable, setCompanyAssignedTable,
  setGeneratedAssignedGraph, setAllCompanies, setTop20Companies, setFilter,
} = slice.actions;

export default slice.reducer;
